import {styled} from '@vebox/etui-system';
import {Div, DivProps} from '@vebox/etui-system-elements';
import {Theme} from "@vebox/etui-themes";
import * as React from "react";

interface AccordionSectionContentDivProps extends DivProps {
    isOpen: boolean;
    keepSectionContentInDOM?: boolean;
}

export const AccordionSectionContentDiv: React.FC<AccordionSectionContentDivProps> = styled(Div).attrs(
    ({
         theme,
         isOpen,
         keepSectionContentInDOM,
         ...props
     }: AccordionSectionContentDivProps) => ({
        p: `${(theme as Theme).spacing.md}px`,
        display:
            keepSectionContentInDOM && !isOpen ? 'none' : props.display || 'block',
        height: 'fit-content',
        transition: '0.2s ease-in-out',
        ...props,
    }),
)``;
